/**
 * Unified Clerk appearance theme for Doblaj Studio.
 * Ensures consistent design, circular social buttons, clear sub-step typography (OTP/reset),
 * dark mode contrast, and mobile auto-zoom prevention (>=16px on mobile).
 */
export const clerkAppearance = {
  elements: {
    card: 'bg-transparent shadow-none px-0 w-full max-w-none',
    headerTitle: 'text-base font-medium text-[#0c0a09] dark:text-white mb-1',
    socialButtonsRoot: 'hidden',
    socialButtons: 'hidden',
    dividerRow: 'hidden',
    socialButtonsBlockButton:
      'w-11 h-11 flex items-center justify-center rounded-full border border-[#e7e5e4] dark:border-[#292524] hover:bg-black/5 dark:hover:bg-white/5 transition-colors shrink-0 shadow-sm',
    socialButtonsBlockButtonText: 'hidden',
    socialButtonsProviderIcon: 'w-5 h-5 shrink-0',
    formButtonPrimary:
      'btn-primary w-full py-3 text-sm font-medium rounded-full transition-all shadow-sm active:scale-[0.98]',
    formFieldInput:
      'input-field w-full px-4 py-2.5 rounded-xl text-[16px] md:text-sm text-[#0c0a09] dark:text-white bg-[#fafafa] dark:bg-[#141211] border border-[#e7e5e4] dark:border-[#292524] transition-all',
    formFieldLabel:
      'block text-[11px] font-mono font-medium uppercase tracking-wider text-[#777169] dark:text-[#a8a29e] mb-1.5',
    formFieldErrorText:
      'text-xs text-red-500 dark:text-red-400 mt-1.5 font-sans',
    formFieldWarningText:
      'text-xs text-amber-500 dark:text-amber-400 mt-1.5 font-sans',
    formFieldSuccessText:
      'text-xs text-emerald-500 dark:text-emerald-400 mt-1.5 font-sans',
    alert:
      'p-3 rounded-xl bg-red-500/10 border border-red-500/20 text-red-600 dark:text-red-400 text-xs mb-4',
    alertText: 'text-xs text-red-600 dark:text-red-400 font-sans',
    footerActionLink:
      'text-[#0c0a09] dark:text-white hover:underline font-medium text-xs',
    footerActionText: 'text-xs text-[#777169] dark:text-[#a8a29e]',
    dividerLine: 'bg-[#e7e5e4] dark:bg-[#292524]',
    dividerText:
      'text-[#777169] dark:text-[#a8a29e] bg-transparent uppercase tracking-widest text-[10px] font-mono',
    identityPreviewText: 'text-[#0c0a09] dark:text-white text-xs font-medium',
    identityPreviewEditButton:
      'text-[#777169] dark:text-[#a8a29e] hover:text-[#0c0a09] dark:hover:text-white text-xs underline ml-2',
    formFieldInputShowPasswordButton:
      'text-[#777169] dark:text-[#a8a29e] hover:text-[#0c0a09] dark:hover:text-white',
    otpCodeFieldInput:
      'rounded-xl border border-[#e7e5e4] dark:border-[#292524] text-[#0c0a09] dark:text-white bg-[#fafafa] dark:bg-[#141211] text-lg font-mono focus:border-[#292524] dark:focus:border-white/40',
  },
  layout: {
    socialButtonsPlacement: 'bottom' as const,
    socialButtonsVariant: 'iconButton' as const,
    termsPageUrl: '/terms',
    privacyPageUrl: '/privacy-policy',
  },
};
